<template>
    <div class="teamdetails_box">
        <el-form label-position="top" label-width="80px" :model="form" ref="form">
            <el-form-item label="成员姓名" prop="username" :rules="[
					  { required: true, message: '请输入成员姓名'},
					]">
                <el-input v-model="form.username"  maxlength="20"></el-input>
            </el-form-item>
            <el-form-item label="成员职位" prop="position" :rules="[
					  { required: true, message: '请输入成员职位'},
					]">
                <el-input v-model="form.position"  maxlength="20"></el-input>
            </el-form-item>

            <el-form-item label="成员头像" prop="avatar" :rules="[
					  { required: true, message: '请上传成员头像'},
					]">
                <el-upload class="avatar-uploader" ref="upload" action="" :auto-upload="true" name="image7"
                    :http-request="upload" :before-upload="beforeUploadFile" :on-change="handleChange"
                    :file-list='fileList' :on-remove="handleRemove">
                    <el-button size="small">点击上传</el-button>
                    <div slot="tip" class="el-upload__tip">jpg格式,建议大小:150x150</div>
                </el-upload>
                <div>
                    <img :src="form.avatar" class="img" v-if="form.avatar">
                </div>
            </el-form-item>
            <el-button class="btn" type="primary" @click="Save">保存成员</el-button>

        </el-form>
    </div>
</template>

<script>
    import {
        teamAdd,
        teamEdit
    } from '../api/api'
    import local from '../utils/local';
    import axios from "axios";
    export default {
        data() {
            return {
                form: {
                    avatar: '',
                    username: '',
                    position: '',
                    admin_id: local.get('admin_id')
                },
                fileList: []
            }
        },
        methods: {

            handleRemove(file, fileList) {
                this.fileList.shift();
                this.form.avatar=''
            },
            beforeUploadFile(file) {
                const isJPG = file.type === "image/jpeg";
                const isLt2M = file.size / 1024 / 1024 < 2;

                if (!isJPG) {
                    this.$message.error("上传图片只能是 JPG格式!");
                }
                if (!isLt2M) {
                    this.$message.error("上传图片大小不能超过 2MB!");
                }
                return (isJPG && isLt2M);
            },
            handleChange(file, fileList) {
                if (fileList.length > 0) {
                    this.fileList = [fileList[fileList.length - 1]]; // 这一步，是 展示最后一次选择的csv文件
                }

            },
            upload(file) {
                var formD = new FormData();
                formD.append('file', file.file);
                axios.post('http://api1.home.didigo.es/admin/admin/photo', formD).then(res => {
                    if (res.data.status == 200) {
                        this.form.avatar = res.data.data.url;

                    }
                })

            },
            Save() {
                this.$refs["form"].validate(valid => {
                    if (valid) {
                        if (this.form.id) {
                            teamEdit(this.form.admin_id, this.form.username, this.form.avatar, this.form
                                    .position, this.form.id)
                                .then(res => {
                                    if (res.data.status == 200) {
                                        this.$message({
                                            type: 'success',
                                            message: '保存成功'
                                        })

                                        this.$router.push('/home/team')
                                    } else {
                                        this.$message.error(res.data.msg)
                                    }
                                })
                        } else {
                            teamAdd(this.form.admin_id, this.form.username, this.form.avatar, this.form
                                .position).then(res => {
                                if (res.data.status == 200) {
                                    this.$message({
                                        type: 'success',
                                        message: '保存成功'
                                    })

                                    this.$router.push('/home/team')
                                } else {
                                    this.$message.error(res.data.msg)
                                }
                            })
                        }
                    }
                })

            }
        },
        created() {
            if (this.$route.query.data) {
                let data = JSON.parse(this.$route.query.data);
                Object.assign(this.form, data)
            }
        }
    }
</script>

<style lang="less" scoped>
    .teamdetails_box {
        padding: 0 50px;

        .el-form-item {
            // margin: 0;

            .el-form--label-top .el-form-item__label {
                padding: 0 !important;
            }

            .el-input {
                width: 800px;
            }

            .el-upload__tip {
                margin: 0;
            }

            .img {
                width: 110px;
            }

        }

        .btn {
            margin-top: 20px;
        }
    }
</style>